import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
} from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';
import './editor.scss';
import { PanelBody, TextControl, ToggleControl } from '@wordpress/components';

export default function Edit( { attributes, setAttributes } ) {
	const { themeDark } = attributes;

	const onThemeDark = ( newLinkTarget ) => {
		setAttributes( { themeDark: newLinkTarget } );
	};

	useEffect( () => {
		const accordionHeaders =
			document.querySelectorAll( '.accordion-header' );

		accordionHeaders.forEach( ( header ) => {
			header.addEventListener( 'click', () => {
				const accordionItem = header.parentElement;
				const accordionContent =
					accordionItem.querySelector( '.accordion-content' );
				const activeAccordionItem = document.querySelector(
					'.accordion-item.active'
				);

				if (
					activeAccordionItem &&
					activeAccordionItem !== accordionItem
				) {
					const activeAccordionContent =
						activeAccordionItem.querySelector(
							'.accordion-content'
						);

					activeAccordionItem.classList.remove( 'active' );
					activeAccordionContent.classList.remove( 'active' );
				}

				header.classList.toggle( 'active' );
				accordionContent.classList.toggle( 'active' );
				accordionItem.classList.toggle( 'active' );
			} );
		} );
	}, [] );
	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleControl
						label={ __( 'Dark Mode', 'ask-faq' ) }
						checked={ themeDark }
						onChange={ onThemeDark }
					/>
				</PanelBody>
			</InspectorControls>
			<div
				{ ...useBlockProps( {
					className: `${
						themeDark &&
						'theme-dark wp-block-create-block-askaccordionfaq'
					}`,
				} ) }
			>
				<div className="ask">
					<div className="ask__container">
						<ul className="ask__accordion__wrapper">
							<InnerBlocks
								allowedBlocks={ [
									'create-block/accordionquestion',
								] }
								orientation="horizontal"
								template={ [
									[ 'create-block/accordionquestion' ],
									[ 'create-block/accordionquestion' ],
									[ 'create-block/accordionquestion' ],
								] }
							/>
						</ul>
					</div>
				</div>
			</div>
		</>
	);
}
